<div class="wrapper-dashboard">
  <span id="store-name" style="display: none;"></span>
  <div class="row">
    <div [@collapse]="visible" class="section-sidenav sidenav-expanded" *ngIf="navOn2" (mouseover)="showNav()"
      (mouseout)="closeNav()">
      <div class="section-text row">
        <div class="col logo-container">
          <!-- Phones show the sidebar as a menu sheet, titled instead of branded -->
          <span class="drawer-title">{{ "Menu" | translate }}</span>
          <div class="logo-width" *ngIf="estoreLogoPlatform != 'estoreglobe'">
            <svg fill="none" viewBox="0 0 617 213" width="100%" xmlns="http://www.w3.org/2000/svg"
              xmlns:xlink="http://www.w3.org/1999/xlink">
              <clipPath id="a">
                <path d="m0 0h617v212.647h-617z" />
              </clipPath>
              <g clip-path="url(#a)">
                <path clip-rule="evenodd"
                  d="m120.43 51.5883-52.5849 18.5595c-5.1554 2.32-14.5383 9.4345-10.8264 19.3329 2.8356 6.4443 11.136 19.0233 21.6531 17.7863 1.5466-.258 5.2585-.928 7.7331-1.547l74.2381-23.9724c6.96-3.0933 19.333-15.621 13.146-40.9857-3.351-15.4663-20.724-45.16153-63.411-40.212316-22.1687 1.804466-74.5478 16.858416-106.71769 62.638616-3.351025 6.7021-7.42381 19.0235 3.09326 14.693l79.65133-34.0258c5.9285-3.0932 19.7961-8.661 27.8391-6.1866 6.186 2.3199 16.085 8.3515 6.186 13.9195zm-89.7038 37.1195c6.1865 12.8882 22.8901 38.5112 40.2123 37.8922 3.6088 0 13.4557-.464 23.9728-2.32l65.7317-20.879c3.093-1.805 10.208-4.6402 13.92-1.547.773 1.805 1.237 7.115-3.094 13.92-4.124 12.115-31.242 39.439-106.717 51.812-15.724.773-49.1827-5.413-57.2252-36.346-3.6088-9.795-4.02123-32.0152 23.1994-42.5322z"
                  fill="#ffb319" fill-rule="evenodd" />
                <g fill="#2e3192">
                  <path clip-rule="evenodd"
                    d="m287.815 36.1913-15.467 17.7862c-5.928-4.8977-21.188-13.1464-34.799-6.9598-3.351 3.6088-6.96 11.909 5.413 16.2396 9.538 2.5777 30.16 9.4344 36.346 16.2396 4.382 3.351 12.837 13.7649 11.6 28.6121-.516 9.022-7.115 28.613-29.386 34.8-14.951 3.866-49.492 6.186-68.052-15.467l17.013-18.559c4.382 4.124 15.931 12.218 27.066 11.599 5.929.258 17.632-1.701 17.013-11.599.516-3.093-2.165-10.0533-17.013-13.1465-11.857-2.8355-36.191-12.9917-38.666-30.9326-1.804-10.3109-.154-32.6339 20.88-39.439 13.662-4.8977 46.399-9.5891 68.052 10.8264zm49.492-8.5072-32.479 3.8666-.773 19.3328h-10.826v22.4261h10.826v37.8924c0 19.178 10.311 28.613 15.466 30.933 19.797 8.042 38.15.773 44.852-3.867l-10.826-21.653c-12.373 7.424-15.982-1.546-16.24-6.96v-36.3454h17.787l3.866-22.4261h-21.653zm222.714 78.8799 55.679-.773c3.351-16.4977.773-51.1937-36.346-57.9989-12.889-2.0622-40.677.464-48.719 27.066-4.382 12.3721-8.042 41.9109 12.373 61.0889 10.827 8.764 39.903 20.261 69.599-3.866l-13.147-17.787c-11.084 7.478-34.49 16.4-39.439-7.73zm11.6-37.8955c-3.866-.5155-11.599 2.4747-11.599 18.5596h23.199c1.289-5.4132.773-16.7036-11.6-18.5596zm-166.261-20.8811c12.888-1.0311 40.367 3.5573 47.172 30.1593 4.124 17.529 4.794 55.0613-25.52 64.9603-10.568 3.351-35.881 6.186-52.585-9.28-7.218-7.218-19.178-28.767-9.28-57.2253 3.351-9.2809 16.085-27.997 40.213-28.6143zm1.546 23.9775c3.608-.5155 11.29 1.392 13.146 13.1463 1.289 9.5367 2.01 29.8478-5.413 34.7968-2.062 1.289-7.579 3.093-13.147 0-2.835-1.545-7.733-10.667-4.64-34.7968.774-4.3821 3.867-13.1463 10.054-13.1463zm58.772-20.8825v92.0246h34.026v-42.532c.515-8.7647 6.186-24.5919 24.746-17.7867l5.413-33.2525c-7.733-2.8355-24.901-3.0933-31.706 18.5595l-3.093-17.0129z"
                    fill-rule="evenodd" />
                  <path d="m467.903 211.515h-4.903v-34.03h18.544v4.224h-13.641v11.505h11.942v4.223h-11.942z" />
                  <path d="m497.655 211.515v-34.03h4.902v34.03z" />
                  <path
                    d="m528.567 211.515-11.068-34.03h5.389l7.087 22.719c.388 1.408 1.893 6.019 2.185 7.427h.194c.291-1.408 1.699-6.019 2.087-7.476l7.088-22.67h5.145l-11.116 34.03z" />
                  <path
                    d="m569.594 211.951c-6.165 0-8.884-3.203-10.243-6.116l4.757-2.185c.922 2.233 2.573 4.127 5.922 4.127 3.835 0 5.68-2.525 5.68-6.748 0-4.272-2.039-6.311-5.777-6.311-2.087 0-3.543.874-4.417 1.845l-4.709-1.602 1.457-16.893h16.747v4.175h-12.476l-.922 10.048.194.049c1.117-.874 3.058-1.602 5.194-1.602 6.263 0 9.612 3.349 9.612 9.806 0 7.039-4.223 11.407-11.019 11.407z" />
                  <path
                    d="m605.854 207.68c4.126 0 6.262-2.185 6.262-4.952 0-7.039-16.019-5.582-16.019-16.311 0-5.339 4.514-9.417 10.922-9.417 4.369 0 7.573 1.65 9.224 3.204l-3.01 3.738c-1.456-1.262-3.495-2.573-6.554-2.573-3.543 0-5.631 1.99-5.631 4.709 0 7.136 16.068 5.728 16.068 16.359 0 5.097-4.126 9.563-11.796 9.563-5.582 0-9.272-2.136-11.019-3.738l2.864-4.029c1.796 1.505 4.563 3.447 8.689 3.447z" />
                </g>
              </g>
            </svg>
          </div>
          <div class="logo-width" *ngIf="estoreLogoPlatform === 'estoreglobe'">
            <svg width="100%" viewBox="0 0 617 213" fill="none" xmlns="http://www.w3.org/2000/svg">
              <g clip-path="url(#clip0_3635_82622)">
                <path fill-rule="evenodd" clip-rule="evenodd"
                  d="M120.43 51.5883L67.8451 70.1478C62.6897 72.4678 53.3068 79.5823 57.0187 89.4807C59.8543 95.925 68.1547 108.504 78.6718 107.267C80.2184 107.009 83.9303 106.339 86.4049 105.72L160.643 81.7476C167.603 78.6543 179.976 66.1266 173.789 40.7619C170.438 25.2956 153.065 -4.39963 110.378 0.549584C88.2093 2.35405 35.8302 17.408 3.66031 63.1882C0.309285 69.8903 -3.7635 82.2117 6.75357 77.8812L86.4049 43.8554C92.3334 40.7622 106.201 35.1944 114.244 37.6688C120.43 39.9887 130.329 46.0203 120.43 51.5883ZM30.7262 88.7078C36.9127 101.596 53.6163 127.219 70.9385 126.6C74.5473 126.6 84.3942 126.136 94.9113 124.28L160.643 103.401C163.736 101.596 170.851 98.7608 174.563 101.854C175.336 103.659 175.8 108.969 171.469 115.774C167.345 127.889 140.227 155.213 64.752 167.586C49.028 168.359 15.5693 162.173 7.5268 131.24C3.918 121.445 3.50557 99.2248 30.7262 88.7078Z"
                  fill="#FFB319" />
                <path fill-rule="evenodd" clip-rule="evenodd"
                  d="M287.815 36.1913L272.348 53.9775C266.42 49.0798 251.16 40.8311 237.549 47.0177C234.198 50.6265 230.589 58.9267 242.962 63.2573C252.5 65.835 273.122 72.6917 279.308 79.4969C283.69 82.8479 292.145 93.2618 290.908 108.109C290.392 117.131 283.793 136.722 261.522 142.909C246.571 146.775 212.03 149.095 193.47 127.442L210.483 108.883C214.865 113.007 226.414 121.101 237.549 120.482C243.478 120.74 255.181 118.781 254.562 108.883C255.078 105.79 252.397 98.8297 237.549 95.7365C225.692 92.901 201.358 82.7448 198.883 64.8039C197.079 54.493 198.729 32.17 219.763 25.3649C233.425 20.4672 266.162 15.7758 287.815 36.1913ZM337.307 27.6841L304.828 31.5507L304.055 50.8835H293.229V73.3096H304.055V111.202C304.055 130.38 314.366 139.815 319.521 142.135C339.318 150.177 357.671 142.908 364.373 138.268L353.547 116.615C341.174 124.039 337.565 115.069 337.307 109.655V73.3096H355.094L358.96 50.8835H337.307V27.6841ZM560.021 106.564L615.7 105.791C619.051 89.2933 616.473 54.5973 579.354 47.7921C566.465 45.7299 538.677 48.2561 530.635 74.8581C526.253 87.2302 522.593 116.769 543.008 135.947C553.835 144.711 582.911 156.208 612.607 132.081L599.46 114.294C588.376 121.772 564.97 130.694 560.021 106.564ZM571.621 68.6685C567.755 68.153 560.022 71.1432 560.022 87.2281H583.221C584.51 81.8149 583.994 70.5245 571.621 68.6685ZM405.36 47.7874C418.248 46.7563 445.727 51.3447 452.532 77.9467C456.656 95.4757 457.326 133.008 427.012 142.907C416.444 146.258 391.131 149.093 374.427 133.627C367.209 126.409 355.249 104.86 365.147 76.4017C368.498 67.1208 381.232 48.4047 405.36 47.7874ZM406.906 71.7649C410.514 71.2494 418.196 73.1569 420.052 84.9112C421.341 94.4479 422.062 114.759 414.639 119.708C412.577 120.997 407.06 122.801 401.492 119.708C398.657 118.163 393.759 109.041 396.852 84.9112C397.626 80.5291 400.719 71.7649 406.906 71.7649ZM465.678 50.8824V142.907H499.704V100.375C500.219 91.6103 505.89 75.7831 524.45 82.5883L529.863 49.3358C522.13 46.5003 504.962 46.2425 498.157 67.8953L495.064 50.8824H465.678Z"
                  fill="#2E3192" />
                <path
                  d="M255.459 177.647C261.434 177.647 264.155 179.783 265.223 180.851L262.066 184.444C260.608 183.084 258.519 182.016 255.216 182.016C250.407 182.016 245.403 184.589 245.403 194.832C245.403 204.541 248.804 208.473 255.168 208.473C257.014 208.473 259.2 208.133 260.365 207.405V194.783H265.272V209.589C262.989 211.385 259.685 212.647 254.147 212.647C245.063 212.647 240.4 206.871 240.4 195.317C240.4 183.036 247.055 177.647 255.459 177.647Z"
                  fill="#2E3192" />
                <path d="M282.935 178.133H287.793V207.939H301.832V212.162H282.935V178.133Z" fill="#2E3192" />
                <path
                  d="M319.295 194.929C319.295 204.978 322.647 208.376 327.845 208.376C332.946 208.376 336.152 205.22 336.152 195.317C336.152 185.317 332.848 181.919 327.602 181.919C322.647 181.919 319.295 184.978 319.295 194.929ZM341.204 194.978C341.204 207.502 335.763 212.647 327.505 212.647C319.295 212.647 314.292 207.939 314.292 195.317C314.292 182.842 319.732 177.647 327.942 177.647C336.103 177.647 341.204 182.405 341.204 194.978Z"
                  fill="#2E3192" />
                <path
                  d="M374.235 194.589C377.733 195.026 380.696 197.453 380.696 202.308C380.696 207.55 377.684 212.162 368.6 212.162H358.01V178.133H368.94C374.43 178.133 378.996 180.317 378.996 186.871C378.996 190.9 376.956 193.618 374.235 194.395V194.589ZM374.187 187.453C374.187 183.958 372.049 182.308 368.163 182.308H362.819V192.842H368.212C372.341 192.842 374.187 191.046 374.187 187.453ZM369.183 207.987C373.749 207.987 375.693 206.094 375.693 202.55C375.693 198.279 372.584 197.065 368.94 197.065H362.819V207.987H369.183Z"
                  fill="#2E3192" />
                <path
                  d="M416.995 212.162H397.71V178.133H416.364V182.356H402.568V192.793H414.615V197.016H402.568V207.939H416.995V212.162Z"
                  fill="#2E3192" />
                <path
                  d="M450.13 200.657H450.373L459.165 178.133H466.792V212.162H462.031V183.91H461.788C459.845 188.618 454.404 202.793 452.461 207.502H447.749L438.471 183.91H438.179V212.162H433.565V178.133H441.337L450.13 200.657Z"
                  fill="#2E3192" />
                <path
                  d="M504.644 212.162H485.359V178.133H504.013V182.356H490.217V192.793H502.264V197.016H490.217V207.939H504.644V212.162Z"
                  fill="#2E3192" />
                <path
                  d="M521.214 178.133H530.492C537.682 178.133 541.956 180.948 541.956 187.842C541.956 193.521 538.459 196.628 534.427 197.162V197.356C535.884 198.036 537.099 199.201 538.653 201.919L544.628 212.162H538.75L532.727 201.24C531.658 199.298 530.298 198.473 528.063 198.473H526.071V212.162H521.214V178.133ZM526.071 182.356V194.395H530.006C534.475 194.395 536.953 192.55 536.953 188.279C536.953 184.007 534.427 182.356 529.812 182.356H526.071Z"
                  fill="#2E3192" />
                <path
                  d="M558.405 195.414C558.405 184.395 563.312 177.647 572.639 177.647C578.274 177.647 581.091 179.832 582.16 180.803L579.002 184.492C577.691 183.23 575.796 181.968 572.25 181.968C566.664 181.968 563.409 186.046 563.409 195.075C563.409 203.618 566.566 208.279 572.687 208.279C576.039 208.279 577.982 207.162 579.148 205.997L581.869 209.444C580.411 210.997 577.254 212.647 572.104 212.647C562.437 212.647 558.405 205.803 558.405 195.414Z"
                  fill="#2E3192" />
                <path
                  d="M617 212.162H597.714V178.133H616.368V182.356H602.572V192.793H614.62V197.016H602.572V207.939H617V212.162Z"
                  fill="#2E3192" />
              </g>
              <defs>
                <clipPath id="clip0_3635_82622">
                  <rect width="617" height="212.647" fill="white" />
                </clipPath>
              </defs>
            </svg>
          </div>
          <div class="collapse-btn-container">
            <button class="btn btn-collapse sidebar-toggle" (click)="collapseMenu()">
              <i class="fi fi-rr-apps"></i>
            </button>
            <button type="button" class="drawer-close-btn" (click)="collapseMenuMobile()"
              [attr.aria-label]="'Close' | translate">
              <i class="fi fi-rr-cross-small"></i>
            </button>
          </div>
        </div>
      </div>
      <div class="section-navs">
        <ul class="section-links custom-scrollbar">
          <li class="nav-link border-nav" routerLink="/dashboard/overview" routerLinkActive="border-active"
            (click)="toggleOffAll(); mobileToggle && collapseMenuMobile()">
            <a class="link" routerLinkActive="link-active" (click)="goTo('/dashboard/overview')">
              <div class="icon-box" routerLinkActive="icon-box-active">
                <i class="fi fi-rr-home"></i>
              </div>
              <span id="dashboard">{{ "Dashboard" | translate }}</span>
            </a>
          </li>
          <li id="stores3" class="nav-link border-nav" routerLink="/dashboard/list-stores"
            routerLinkActive="border-active" (click)="toggleOffAll(); mobileToggle && collapseMenuMobile()">
            <a class="link" id="stores2" routerLinkActive="link-active" (click)="goTo('/dashboard/list-stores')">
              <div class="icon-box" routerLinkActive="icon-box-active">
                <i class="fi fi-rr-shop"></i>
              </div>
              <span id="stores">{{ "Stores" | translate
                }}<b class="badge badge-primary store-amount">
                  {{ dataService.storeAmount }}
                </b></span>
            </a>
          </li>
          <!--li class="nav-link border-nav" routerLinkActive="border-active">
                        <a class="link" routerLink='/dashboard/billing' routerLinkActive="link-active">Subscription/Billing</a>
                    </li-->
          <li (click)="collapse.toggle()" class="nav-link border-nav" (click)="toggleOff(0)"
            ngClass="{{ borderActive1 }}">
            <a class="link" routerLinkActive="link-active" style="cursor: pointer">
              <div class="icon-box" routerLinkActive="icon-box-active">
                <i class="fi fi-rr-ticket"></i>
              </div>
              <span id="my-sales">{{ "My Sales" | translate }}</span>
            </a>
            <a class="link-icon" [(ngbCollapse)]="!isCollapsed1"><i class="fi fi-rr-angle-right"></i></a>
            <a class="link-icon" [(ngbCollapse)]="isCollapsed1"><i class="fi fi-rr-angle-down"></i></a>
          </li>
          <div #collapse="ngbCollapse" [(ngbCollapse)]="isCollapsed1">
            <div class="card border-0">
              <ul class="subnav">
                <li id="orders" class="nav_2" [class.active_2]="
                    router.url.startsWith('/dashboard/orders') ||
                    router.url.startsWith('/dashboard/order-subscription')
                  " routerLink="/dashboard/orders" (click)="goTo('/dashboard/orders'); mobileToggle && collapseMenuMobile()">
                  {{ "Orders" | translate }}
                </li>
                <li id="customers" class="nav_2" [class.active_2]="
                    router.url.startsWith('/dashboard/customers') ||
                    router.url.startsWith('/dashboard/abandoned-carts')
                  " routerLink="/dashboard/customers" (click)="goTo('/dashboard/customers'); mobileToggle && collapseMenuMobile()">
                  {{ "Customers & Carts" | translate }}
                </li>
              </ul>
            </div>
          </div>
          <li class="nav-link border-nav" routerLink="/dashboard/product-manager" routerLinkActive="border-active"
            (click)="toggleOffAll(); mobileToggle && collapseMenuMobile()">
            <a class="link" routerLinkActive="link-active" (click)="goTo('/dashboard/product-manager')">
              <div class="icon-box" routerLinkActive="icon-box-active">
                <i class="fi fi-rr-address-book"></i>
              </div>
              <span id="catalog">{{ "Catalog" | translate }}</span>
            </a>
          </li>
          <li (click)="collapse3.toggle()" class="nav-link border-nav" (click)="toggleOff(2)"
            ngClass="{{ borderActive3 }}" *ngIf="estoreLogoPlatform !== 'estoreglobe'">
            <a class="link" routerLinkActive="link-active" style="cursor: pointer">
              <div class="icon-box" routerLinkActive="icon-box-active">
                <i class="fi fi-rr-stats"></i>
              </div>
              <span id="marketing">{{ "Marketing" | translate }}</span>
            </a>
            <a class="link-icon" [(ngbCollapse)]="!isCollapsed3"><i class="fi fi-rr-angle-right"></i></a>
            <a class="link-icon" [(ngbCollapse)]="isCollapsed3"><i class="fi fi-rr-angle-down"></i></a>
          </li>
          <div #collapse3="ngbCollapse" [(ngbCollapse)]="isCollapsed3">
            <div class="card border-0">
              <ul class="subnav">
                <!-- <li class="nav_2"  routerLinkActive="active_2"><i class="fi fi-rr-megaphone"></i> Google Ads</li>
                                <li class="nav_2" routerLinkActive="active_2"><i class="fi fi-rr-browser"></i> Facebook Ads</li> -->
                <!--                <li-->
                <!--                  id="auto-discounts"-->
                <!--                  class="nav_2"-->
                <!--                  routerLink="/dashboard/discounts"-->
                <!--                  routerLinkActive="active_2"-->
                <!--                >-->
                <!--                  - {{ "Automatic Discounts" | translate }}-->
                <!--                </li>-->
                <li id="auto-emails" class="nav_2" routerLink="/dashboard/email-template" routerLinkActive="active_2"
                  (click)="goTo('/dashboard/email-template'); mobileToggle && collapseMenuMobile()" *ngIf="estoreLogoPlatform !== 'globemerce' && estoreLogoPlatform !== 'gm' && estoreLogoPlatform !== 'estoreglobe'">
                  {{ "Automated Emails" | translate }}
                </li>
                <li id="referral" class="nav_2" routerLink="/dashboard/referral" routerLinkActive="active_2"
                  *ngIf="referralStatus" (click)="goTo('/dashboard/referral'); mobileToggle && collapseMenuMobile()">
                  {{ "Referral" | translate }}
                </li>
              </ul>
            </div>
          </div>
          <li (click)="collapse4.toggle()" class="nav-link border-nav" (click)="toggleOff(3)"
            ngClass="{{ borderActive4 }}">
            <a class="link" routerLinkActive="link-active" style="cursor: pointer">
              <div class="icon-box" routerLinkActive="icon-box-active">
                <i class="fi fi-rr-globe"></i>
              </div>
              <span id="website">{{ "Website" | translate }}</span>
            </a>
            <a class="link-icon" [(ngbCollapse)]="!isCollapsed4"><i class="fi fi-rr-angle-right"></i></a>
            <a class="link-icon" [(ngbCollapse)]="isCollapsed4"><i class="fi fi-rr-angle-down"></i></a>
          </li>
          <div #collapse4="ngbCollapse" [(ngbCollapse)]="isCollapsed4">
            <div class="card border-0">
              <ul class="subnav">
                <li id="design" class="nav_2" routerLink="/dashboard/design" routerLinkActive="active_2"
                  (click)="goTo('/dashboard/design'); mobileToggle && collapseMenuMobile()">
                  {{ "Storefront" | translate }}
                </li>
                <li id="pages" class="nav_2" routerLink="/dashboard/pages" [class.active_2]="isLandingPagesRoute"
                  (click)="goTo('/dashboard/pages'); mobileToggle && collapseMenuMobile()">
                  {{ "Landing Pages" | translate }}
                </li>
                <li id="menu-manager" class="nav_2" routerLink="/dashboard/menu-manager" routerLinkActive="active_2"
                  (click)="goTo('/dashboard/menu-manager'); mobileToggle && collapseMenuMobile()">
                  {{ "Menus" | translate }}
                </li>
                <li id="domain" class="nav_2" routerLink="/dashboard/domain" routerLinkActive="active_2"
                  (click)="goTo('/dashboard/domain'); mobileToggle && collapseMenuMobile()">
                  {{ "Domain" | translate }}
                </li>
                <li id="media-library" class="nav_2" routerLink="/dashboard/gallery" routerLinkActive="active_2"
                  (click)="goTo('/dashboard/gallery'); mobileToggle && collapseMenuMobile()">
                  {{ "Media Library" | translate }}
                </li>
              </ul>
            </div>
          </div>
          <li class="nav-link border-nav" routerLink="/dashboard/express-checkout" routerLinkActive="border-active"
            (click)="toggleOffAll(); mobileToggle && collapseMenuMobile()">
            <a class="link" routerLinkActive="link-active" (click)="goTo('/dashboard/express-checkout')">
              <div class="icon-box" routerLinkActive="icon-box-active">
                <i class="fi fi-rr-shopping-cart"></i>
              </div>
              <span id="express-checkout">{{
                "Express Checkout" | translate
                }}</span>
            </a>
          </li>
          <li class="nav-link border-nav" routerLink="/dashboard/visitor-intelligence" routerLinkActive="border-active"
            (click)="toggleOffAll(); mobileToggle && collapseMenuMobile()">
            <a class="link" routerLinkActive="link-active" (click)="goTo('/dashboard/visitor-intelligence')">
              <div class="icon-box" routerLinkActive="icon-box-active">
                <i class="fi fi-rr-eye"></i>
              </div>
              <span id="visitor-intelligence">{{ "Visitor Intelligence" | translate }}</span>
            </a>
          </li>
          <li (click)="collapse6.toggle()" class="nav-link border-nav" (click)="toggleOff(5)"
            ngClass="{{ borderActive6 }}">
            <a class="link" routerLinkActive="link-active" style="cursor: pointer">
              <div class="icon-box" routerLinkActive="icon-box-active">
                <i class="fi fi-rr-file-chart-line"></i>
              </div>
              <span id="insights">{{ "Insights" | translate }}</span>
            </a>
            <a class="link-icon" [(ngbCollapse)]="!isCollapsed6"><i class="fi fi-rr-angle-right"></i></a>
            <a class="link-icon" [(ngbCollapse)]="isCollapsed6"><i class="fi fi-rr-angle-down"></i></a>
          </li>
          <div #collapse6="ngbCollapse" [(ngbCollapse)]="isCollapsed6">
            <div class="card border-0">
              <ul class="subnav">
                <li id="revenue-lost-report" class="nav_2" routerLink="/dashboard/revenue-lost-report"
                  routerLinkActive="active_2" (click)="goTo('/dashboard/revenue-lost-report'); mobileToggle && collapseMenuMobile()">
                  {{ "Revenue Lost" | translate }}
                </li>
                <li id="landing-page-report" class="nav_2" routerLink="/dashboard/landing-page-report"
                  routerLinkActive="active_2" (click)="goTo('/dashboard/landing-page-report'); mobileToggle && collapseMenuMobile()">
                  {{ "Landing Pages" | translate }}
                </li>
                <li id="express-checkout-report" class="nav_2" routerLink="/dashboard/express-checkout-dashboard"
                  routerLinkActive="active_2" (click)="goTo('/dashboard/express-checkout-dashboard'); mobileToggle && collapseMenuMobile()">
                  {{ "Express Checkout" | translate }}
                </li>
              </ul>
            </div>
          </div>
          <li class="nav-link border-nav" routerLink="/dashboard/preferences" routerLinkActive="border-active"
            (click)="toggleOffAll(); mobileToggle && collapseMenuMobile()">
            <a class="link" routerLinkActive="link-active" (click)="goTo('/dashboard/preferences')">
              <div class="icon-box" routerLinkActive="icon-box-active">
                <i class="fi fi-rr-settings"></i>
              </div>
              <span id="preference">{{ "Preferences" | translate }}</span>
            </a>
          </li>
          <!-- <li class="nav-link border-nav" routerLink="/dashboard/ai-landing-page" routerLinkActive="border-active"
            (click)="toggleOffAll()">
            <a class="link" routerLinkActive="link-active" (click)="goTo('/dashboard/ai-landing-page')">
              <div class="icon-box" routerLinkActive="icon-box-active">
                <i class="fi fi-rr-stars"></i>
              </div>
              <span id="ai-landing-page">{{ "AI Landing Page" | translate }}</span>
            </a>
          </li> -->
        </ul>
        <!-- Menu sheet footer: the top bar's language and theme switches live here on phones -->
        <div class="drawer-quick-settings">
          <button type="button" class="drawer-quick-btn" [matMenuTriggerFor]="languageSelector"
            [attr.aria-label]="'Select Language' | translate">
            <img class="language-flag-circle" [src]="dashboardLanguage?.languageFlag" alt="" />
            <span class="drawer-quick-label">{{ dashboardLanguage?.languageName }}</span>
            <i class="fi fi-rr-angle-small-down"></i>
          </button>
          <button type="button" class="drawer-quick-btn" (click)="toggleDarkMode()">
            <i class="fi fi-rr-moon theme-when-light"></i>
            <i class="fi fi-rr-sun theme-when-dark"></i>
            <span class="drawer-quick-label theme-when-light">{{ "Dark mode" | translate }}</span>
            <span class="drawer-quick-label theme-when-dark">{{ "Light mode" | translate }}</span>
          </button>
        </div>
        <div class="nav-bottom-container">
          <!-- Side nav bottom actions -->
          <div class="section-actions">
            <div class="d-flex justify-end flex-row-sm">
              <div class="section profile-nav on-click-dropdown" (click)="onClickDisplayBtmMenu()">
                <div class="media profile-media">
                  <!-- <img class="b-r-10 profile-image" src="assets/profile-placeholder.png" alt=""> -->
                  <div class="profile-box">
                    <span id="first-letter-name">{{ firstLetter }}</span>
                  </div>
                  <div class="media-body">
                    <span id="full-name">{{ dealerName }}</span>
                    <p class="mb-0 font-roboto">
                      {{ "Admin" | translate }}
                      <i class="middle fa fa-angle-down"></i>
                    </p>
                  </div>
                </div>
                <div class="bottom-profile-dropdown" ngClass="{{
                    isVisibleBtmMenu ? 'on-click-show' : 'on-click-hide'
                  }}">
                  <div class="profile-dropdown">
                    <div class="dealer-info d-flex">
                      <div class="col-9 d-flex flex-wrap">
                        <div class="dealer-name col-12 p-0">
                          {{ dealerName }}
                        </div>
                        <div class="col-12 d-flex align-items-center p-0">
                          <div class="dealer-role">
                            {{ "Admin" | translate }}
                          </div>
                          <div class="plan-badge ml-2 flex justify-content-start align-items-center gap-1"
                            *ngIf="planName?.toLowerCase() !== 'standard'">
                            <div class="plan-badge-icon"></div>
                            <span>{{ planName | translate }}</span>
                          </div>
                          <div class="border-between ml-2 mb-1">|</div>
                          <div class="status-badge ml-2" [ngClass]="statusClass">
                            {{ dealerStatus | translate }}
                          </div>
                        </div>
                      </div>
                      <div class="col-3 d-flex justify-content-end">
                        <div class="setting-btn align-self-center" (click)="gotoSetting()">
                          <svg width="30" height="30" viewBox="0 0 24 24" fill="none"
                            xmlns="http://www.w3.org/2000/svg">
                            <path
                              d="M18.988 2.01172L21.988 5.01172L19.701 7.29972L16.701 4.29972L18.988 2.01172ZM8 15.9997H11L18.287 8.71272L15.287 5.71272L8 12.9997V15.9997Z"
                              fill="#386BDF" />
                            <path
                              d="M19 19H8.158C8.132 19 8.105 19.01 8.079 19.01C8.046 19.01 8.013 19.001 7.979 19H5V5H11.847L13.847 3H5C3.897 3 3 3.896 3 5V19C3 20.104 3.897 21 5 21H19C19.5304 21 20.0391 20.7893 20.4142 20.4142C20.7893 20.0391 21 19.5304 21 19V10.332L19 12.332V19Z"
                              fill="#386BDF" />
                          </svg>
                        </div>
                      </div>
                    </div>
                    <div class="store-info d-flex mt-2 flex-wrap">
                      <div class="col-6 d-flex justify-content-start store-wording">
                        {{ "Store" | translate }}
                      </div>
                      <div class="col-6 d-flex justify-content-end">
                        <div class="manage-btn" (click)="gotoStore()">
                          <u>{{ "Manage" | translate }}</u>
                        </div>
                      </div>
                      <div class="col-12 border mt-2 mb-2" style="border-radius: 10px">
                        <div class="row p-0 store-wrapper" *ngFor="let store of stores; let i = index">
                          <div [class.disabled]="!store.status"
                            class="col-12 d-flex flex-wrap align-items-center store-list"
                            (click)="switchStore(store.store_id)">
                            <div class="col-1 p-0">
                              <svg width="24" height="24" viewBox="0 0 20 20" fill="none"
                                xmlns="http://www.w3.org/2000/svg">
                                <path d="M4.75 5.9165V9.4165H14.0833L15.8333 7.6665L14.0833 5.9165H4.75Z"
                                  stroke="#747E8B" stroke-width="1.16667" stroke-linejoin="round" />
                                <path d="M9.70833 9.4165V15.8332M9.70833 4.1665V5.9165M8.25 15.8332H11.1667"
                                  stroke="#747E8B" stroke-width="1.16667" stroke-linecap="round"
                                  stroke-linejoin="round" />
                              </svg>
                            </div>
                            <div class="col-8">
                              <h3>{{ store.store_name }}</h3>
                            </div>
                            <div class="col-3 d-flex justify-content-end p-0">
                              <div *ngIf="+store.store_id === +dataService.storeId">
                                <svg width="20" height="20" viewBox="0 0 20 20" fill="none"
                                  xmlns="http://www.w3.org/2000/svg">
                                  <circle cx="10" cy="10" r="10" fill="#1932FA" />
                                  <path d="M6.71442 10.0777L9.51657 12.8798L14 7.83594" stroke="white"
                                    stroke-width="1.68129" stroke-linecap="round" stroke-linejoin="round" />
                                </svg>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div class="mt-2 mb-2 d-flex w-100" [class.disabled]="
                            !allowCreateStore || isConvertedSuspended
                          " (click)="showCreateStore()" style="cursor: pointer">
                          <div class="col-1 p-0 d-flex justify-content-left flex-wrap align-items-center">
                            <svg width="20" height="20" viewBox="0 0 18 18" fill="none"
                              xmlns="http://www.w3.org/2000/svg">
                              <path
                                d="M9.00008 0.666504C4.39758 0.666504 0.666748 4.39734 0.666748 8.99984C0.666748 13.6023 4.39758 17.3332 9.00008 17.3332C13.6026 17.3332 17.3334 13.6023 17.3334 8.99984C17.3334 4.39734 13.6026 0.666504 9.00008 0.666504ZM13.1667 9.83317H9.83341V13.1665H8.16675V9.83317H4.83341V8.1665H8.16675V4.83317H9.83341V8.1665H13.1667V9.83317Z"
                                fill="#FFDA44" />
                            </svg>
                          </div>
                          <div class="col-11 p-0 d-flex justify-content-start ml-3">
                            <h3>{{ "Create Store" | translate }}</h3>
                          </div>
                        </div>
                      </div>
                      <div class="option mt-1 mb-2" id="logout" (click)="logoutUser()">
                        <!-- <div style="cursor: pointer" class="d-flex">
                          <i>
                            <svg
                              width="32"
                              height="32"
                              viewBox="0 0 20 20"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <path
                                d="M8.33333 14.1673L7.1875 12.959L9.3125 10.834H2.5V9.16732H9.3125L7.1875 7.04232L8.33333 5.83398L12.5 10.0007L8.33333 14.1673Z"
                                fill="black"
                              />
                              <path
                                d="M17.5 17.5V2.5H10V4.16667H15.8333V15.8333H10V17.5H17.5Z"
                                fill="black"
                              />
                            </svg>
                          </i>
                          <h6 style="margin-top: -1px" class="ml-3.5">
                            {{ "Logout" | translate }}
                          </h6>
                        </div> -->
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="settings-icon" id="view-store-nav" (click)="viewStore(); toggleIcon(0)"
                [class.active]="iconActive[0]">
                <i class="fi fi-rr-shop"></i>
              </div>

              <div class="settings-icon" id="setting-nav" [routerLink]="['/dashboard/preferences']" (click)="toggleIcon(2)"
                [class.active]="iconActive[2]">
                <i class="fi fi-rr-settings"></i>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="bg-overlay" *ngIf="mobileToggle" (click)="collapseMenuMobile()"></div>
    <div [@collapse]="!visible" class="section-sidenav sidenav-collapsed" *ngIf="navOn" (mouseover)="showNav()">
      <div class="section-text row">
        <button class="btn btn-collapse toggle-icon">
          <img src="https://cdn.estore5s.com/asset/estore-favicon.png" width="30px" height="28px"
            style="margin-left: 40px" alt="cart" />
        </button>
      </div>
      <div class="section-navs">
        <ul class="section-links-mini custom-scrollbar">
          <li class="nav-link border-nav" routerLinkActive="border-active">
            <a class="link" routerLink="/dashboard/overview" routerLinkActive="link-active"
              (click)="goTo('/dashboard/overview')">
              <i class="fi fi-rr-home"></i></a>
          </li>
          <li class="nav-link border-nav" routerLinkActive="border-active">
            <a class="link" routerLink="/dashboard/list-stores" routerLinkActive="link-active"
              (click)="goTo('/dashboard/list-stores')">
              <i class="fi fi-rr-shop"></i></a>
          </li>
          <!-- <li class="nav-link border-nav" routerLinkActive="border-active">
            <a
              class="link"
              routerLink="/dashboard/orders"
              routerLinkActive="link-active"
            >
              <i class="fi fi-rr-time-past"></i
            ></a>
          </li> -->
          <!-- <li class="nav-link border-nav" routerLinkActive="border-active">
            <a
              class="link"
              routerLink="/dashboard/abandoned-carts"
              routerLinkActive="link-active"
            >
              <i class="fi fi-rr-info"></i
            ></a>
          </li> -->
          <!-- <li class="nav-link border-nav" routerLinkActive="border-active">
            <a
              class="link"
              routerLink="/dashboard/customers"
              routerLinkActive="link-active"
            >
              <i class="fi fi-rr-user"></i
            ></a>
          </li> -->
          <!-- <li class="nav-link border-nav"  routerLinkActive="border-active">
                        <a class="link" routerLink='/dashboard/product-manager' routerLinkActive="link-active">
                            <i class="fi fi-rr-megaphone"></i></a>
                    </li>
                    <li class="nav-link border-nav"  routerLinkActive="border-active">
                        <a class="link" routerLink='/dashboard/product-manager' routerLinkActive="active_2">
                            <i class="fi fi-rr-browser"></i></a>
                    </li>-->
          <li class="nav-link border-nav" routerLinkActive="border-active">
            <a class="link" routerLink="/dashboard/orders" routerLinkActive="link-active"
              (click)="goTo('/dashboard/orders')">
              <i class="fi fi-rr-ticket"></i></a>
          </li>
          <li class="nav-link border-nav" routerLinkActive="border-active">
            <a class="link" routerLink="/dashboard/product-manager" routerLinkActive="link-active"
              (click)="goTo('/dashboard/product-manager')">
              <i class="fi fi-rr-address-book"></i>
              <!-- <i class="fi fi-rr-document"></i> -->
            </a>
          </li>
          <li class="nav-link border-nav" routerLinkActive="border-active">
            <a class="link" routerLink="/dashboard/discounts" routerLinkActive="link-active"
              (click)="goTo('/dashboard/discounts')">
              <i class="fi fi-rr-stats"></i>
              <!-- <i class="fi fi-rr-layers"></i> -->
            </a>
          </li>
          <li class="nav-link border-nav" routerLinkActive="border-active">
            <a class="link" routerLink="/dashboard/pages" routerLinkActive="link-active"
              (click)="goTo('/dashboard/pages')">
              <i class="fi fi-rr-globe"></i>
              <!-- <i class="fi fi-rr-shopping-cart-add"></i> -->
            </a>
          </li>

          <li class="nav-link border-nav" routerLinkActive="border-active">
            <a class="link" routerLink="/dashboard/express-checkout" routerLinkActive="link-active"
              (click)="goTo('/dashboard/express-checkout')">
              <i class="fi fi-rr-shopping-cart"></i>
              <!-- <i class="fi fi-rr-gallery"></i> -->
            </a>
          </li>
          <li class="nav-link border-nav" routerLinkActive="border-active">
            <a class="link" routerLink="/dashboard/preferences" routerLinkActive="link-active"
              (click)="goTo('/dashboard/preferences')">
              <i class="fi fi-rr-settings"></i></a>
          </li>
          <!--li class="nav-link border-nav" routerLinkActive="border-active">
                        <a class="link" routerLink='/dashboard/payments' routerLinkActive="link-active">Payment Method</a>
                    </li-->
          <li class="nav-link border-nav" routerLinkActive="border-active">
            <a class="link" routerLink="/dashboard/faq" routerLinkActive="link-active" (click)="goTo('/dashboard/faq')">
              <i class="fi fi-rr-interrogation"></i></a>
          </li>
          <!-- <li class="nav-link border-nav" routerLinkActive="border-active">
                        <a class="link" routerLink='/dashboard/e-ticketing-list' routerLinkActive="link-active">
                            <i class="fi fi-rr-notebook"></i></a>
                    </li>
                    <li class="nav-link border-nav" routerLinkActive="border-active">
                        <a class="link" routerLink='/dashboard/knowledge-base' routerLinkActive="link-active">
                            <i class="fi fi fi-rr-bulb"></i></a>
                    </li> -->
        </ul>
      </div>
    </div>

    <div [className]="!navOn ? 'section-main ml-100' : 'w-full section-main'">
      <div class="section-navbar my-4 d-flex justify-content-between">
        <!-- <img class="ellipse-yellow" src="../../assets/ellipse-yellow.png" alt="ellipse">
                <div class="section-logo">
                    <a class="navbar-brand" routerLink="/dashboard/overview">
                        <img class="logo" src="../../assets/logo/estore-logo-caps-white.png" alt="estore-logo">
                    </a>
                </div> -->
        <button type="button" class="mobile-menu-btn" (click)="collapseMenuMobile()"
          [attr.aria-label]="'Menu' | translate">
          <i class="fi fi-rr-menu-burger hamburger-menu"></i>
        </button>
        <div class="section-actions">
          <div class="row d-flex justify-content-between flex-row-sm">
            <!--<div class="search-on-mobile">
              <button class="btn btn-search" routerLink="/dashboard/orders">
                <i class="fi fi-rr-search"></i>
              </button>
            </div>-->
            <!--<div class="store-name pt-3 pr-5" id="store-name"></div>-->

            <!--<div class="form-group">
                            <div ngbDropdown class="d-inline-block w-100">
                                <button class="btn btn-select" id="dropdownBasic1" ngbDropdownToggle style="color:#000;">Store 1</button>
                                <div ngbDropdownMenu aria-labelledby="dropdownBasic1" class="custom-dropdown">
                                    <button ngbDropdownItem>Dropdown 1</button>
                                    <button ngbDropdownItem>Dropdown Active</button>
                                    <button ngbDropdownItem>Dropdown 2</button>
                                    <button ngbDropdownItem>Dropdown 2</button>
                                </div>
                            </div>
                        </div>-->
            <div class="navbar-utility-group d-flex align-items-center">
              <!-- Language Selector -->
              <div class="settings-icon" [matMenuTriggerFor]="languageSelector" id="language-nav" title="{{ 'Select Language' | translate }}">
                <img class="language-flag-circle" [src]="dashboardLanguage?.languageFlag" />
              </div>
              <mat-menu #languageSelector="matMenu" class="language-dropdown-menu" xPosition="before">
                <div class="language-dropdown-header px-3 py-2">
                  <span class="title">{{ "Select Language" | translate }}</span>
                </div>
                <div class="language-list px-2 py-1">
                  <button class="language-item d-flex align-items-center justify-content-between w-100" 
                    *ngFor="let language of dashboardLanguages"
                    [class.active]="language.languageCode === dashboardLanguageCode"
                    mat-menu-item (click)="changeLanguage(language.languageCode)">
                    <div class="d-flex align-items-center">
                      <img class="language-flag mr-2" [src]="language.languageFlag" />
                      <span class="language-name">{{ language.languageName }}</span>
                      <span class="language-code text-muted ml-1">({{ language.languageCode }})</span>
                    </div>
                    <div class="active-indicator" *ngIf="language.languageCode === dashboardLanguageCode">
                      <svg width="18" height="18" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <circle cx="10" cy="10" r="10" fill="#2152ff" />
                        <path d="M6.71442 10.0777L9.51657 12.8798L14 7.83594" stroke="white"
                          stroke-width="1.68129" stroke-linecap="round" stroke-linejoin="round" />
                      </svg>
                    </div>
                  </button>
                </div>
              </mat-menu>
            
              <!-- View Store -->
              <div class="settings-icon" id="view-store-nav" (click)="viewStore(); toggleIcon(0)"
                [class.active]="iconActive[0]" title="{{ 'View My Store' | translate }}">
                <i class="fi fi-rr-shop"></i>
              </div>
            
              <!-- Settings -->
              <div class="settings-icon" id="setting-nav" [routerLink]="['/dashboard/preferences']" (click)="toggleIcon(2)"
                [class.active]="iconActive[2]" title="{{ 'Settings' | translate }}">
                <i class="fi fi-rr-settings"></i>
              </div>
            
              <!-- Dark Mode -->
              <div class="settings-icon" id="darkmode-nav" (click)="toggleDarkMode()" title="{{ 'Toggle Dark Mode' | translate }}">
                <i class="fi fi-rr-moon"></i>
              </div>
            </div>

            <!-- Unified Profile & Store Dropdown -->
            <div class="section profile-nav on-click-dropdown" [class.open]="isVisible" (click)="onClickDisplay(); $event.stopPropagation()">
              <div class="media profile-media">
                <div class="profile-box">
                  <span id="first-letter-name">{{ firstLetter }}</span>
                </div>
                <div class="media-body text-left">
                  <span id="full-name" class="profile-username">{{ dealerName }}</span>
                  <div class="current-store-wrapper">
                    <span class="current-store-name">{{ currentStoreName }}</span>
                    <i class="fa fa-angle-down angle-icon"></i>
                  </div>
                </div>
              </div>
              <div ngClass="{{ isVisible ? 'on-click-show' : 'on-click-hide' }}">
                <div class="profile-dropdown merged-dropdown-card">
                  <!-- Section 1: User & Dealer Info -->
                  <div class="dropdown-user-header">
                    <div class="user-details-col">
                      <div class="dealer-name" [title]="dealerName">{{ dealerName }}</div>
                      <div class="meta-badge-row">
                        <span class="plan-pill" *ngIf="planName?.toLowerCase() !== 'standard'">
                          <i class="plan-crown-icon fi fi-rr-crown"></i>
                          <span>{{ planName | translate }}</span>
                        </span>
                        <span class="status-pill" [ngClass]="statusClass">
                          <span class="status-pulse-dot"></span>
                          <span>{{ dealerStatus | translate }}</span>
                        </span>
                      </div>
                    </div>
                    <button type="button" class="user-edit-btn" (click)="gotoSetting(); $event.stopPropagation()" title="{{ 'Edit Profile' | translate }}">
                      <i class="fi fi-rr-edit"></i>
                    </button>
                  </div>

                  <!-- Section 2: Store Switcher -->
                  <div class="store-dropdown-section">
                    <div class="section-title-bar">
                      <div class="title-with-count">
                        <span class="section-heading">{{ "Switch Store" | translate }}</span>
                        <span class="store-count-badge" *ngIf="stores?.length">{{ stores.length }}</span>
                      </div>
                      <button type="button" class="manage-link-btn" (click)="gotoStore(); $event.stopPropagation()">
                        <span>{{ "Manage" | translate }}</span>
                        <i class="fi fi-rr-angle-small-right"></i>
                      </button>
                    </div>
                    
                    <div class="store-dropdown-list">
                      <div class="store-item"
                        *ngFor="let store of stores"
                        [class.disabled]="!store.status"
                        [class.active]="isStoreActive(store.store_id)"
                        (click)="switchStore(store.store_id); $event.stopPropagation()"
                        [title]="store.store_name">
                        <div class="store-icon-wrap">
                          <i class="fi fi-rr-shop"></i>
                        </div>
                        <div class="store-text-wrap">
                          <span class="store-item-name">{{ store.store_name }}</span>
                          <span class="store-active-badge" *ngIf="isStoreActive(store.store_id)">{{ "Active" | translate }}</span>
                        </div>
                        <div class="selected-check-icon" *ngIf="isStoreActive(store.store_id)">
                          <i class="fi fi-rr-check"></i>
                        </div>
                      </div>
                    </div>

                    <div class="store-dropdown-footer">
                      <button type="button" class="create-store-action-btn"
                        [class.disabled]="!allowCreateStore || isConvertedSuspended"
                        (click)="showCreateStore(); $event.stopPropagation()">
                        <div class="add-icon-circle">
                          <i class="fi fi-rr-plus"></i>
                        </div>
                        <span>{{ "Create Store" | translate }}</span>
                      </button>
                    </div>
                  </div>

                  <!-- Section 3: Logout -->
                  <div class="dropdown-logout-section" id="logout" (click)="logoutUser()">
                    <button type="button" class="logout-action-btn">
                      <div class="logout-icon-wrap">
                        <i class="fi fi-rr-sign-out-alt"></i>
                      </div>
                      <span>{{ "Logout" | translate }}</span>
                    </button>
                  </div>
                </div>
              </div>
            </div>

            <!--<div class="section-notification">
                            <div class="total">3</div>
                            <button mat-button [matMenuTriggerFor]="menu" class="btn btn-notification">
                                <img src="../../assets/icon/notification.svg" alt="noti">
                            </button>
                            <mat-menu #menu="matMenu" class="menu-noti">
                                <div class="arrow"></div>
                                <button mat-menu-item>Notification 1</button>
                                <button mat-menu-item>Notification 2</button>
                                <button mat-menu-item>Notification 3</button>
                            </mat-menu>
                        </div>-->

            <!--<div class="section-btn">
                            <button class="btn btn-create">
                                <img class="plus-icon" src="../../assets/icon/plus-black.png" alt="icon">
                                New Store
                            </button>
                        </div>-->
          </div>
        </div>
        <!--<div class="section-search">
          <form class="form-search" (click)="getSearchOrderHistory()">
            <div class="form-group">
              <i class="fi fi-rr-search"></i>
              <input
                type="text"
                class="form-control"
                name="search"
                placeholder="{{ 'Search By Order ID' | translate }}"
                (keyup)="onKey($event)"
                [(ngModel)]="o_id"
              />
            </div>
          </form>
        </div>-->
        <!-- <img class="ellipse-white" src="../../assets/ellipse-white.png" alt="ellipse"> -->
        <!--<div class="notification-wrapper" (click)="toggleNotificationMobile()">
          <div class="notification-box">
            <div
              class="notification-icon"
              *ngIf="notificationarray.length != 0"
            >
              <i class="fi fi-rr-bell"></i>
              <span class="badge badge-pill badge-secondary">{{
                notificationCountShow
              }}</span>
            </div>
            <div *ngIf="notificationarray.length == 0">
              <i class="fi fi-rr-bell noNotification"></i>
            </div>
            <span
              *ngIf="notificationarray.length != 0"
              class="badge badge-pill badge-secondary"
              >{{ notificationCountShow }}</span
            >
          </div>
          <div
            *ngIf="notificationarray.length != 0"
            class="notification-dropdown onhover-show-div"
            [class.active]="openNotification"
          >
            <h6 class="f-18 mb-0 dropdown-title">Notifications</h6>
            <ul>
              <li
                class="b-l-primary border-4"
                *ngFor="let item of createNotification(); let index = index"
              >
                <p>
                  {{
                    notificationdata[index]["notification_content"]["en-US"][
                      "title"
                    ]
                  }}
                </p>
              </li>

              <li>
                <div *ngIf="notificationarray.length != 0">
                  <a
                    class="btn btn-checkall"
                    routerLink="/dashboard/notification"
                    >View all</a
                  >
                </div>
              </li>
            </ul>
          </div>
        </div>-->

        <div class="theme-switcher" *ngIf="showFestivalTheme">
          <div class="align-middle section-switch">
            <label class="switch">
              <input type="checkbox" [checked]="festivalThemeEnabled" (change)="toggleFestivalTheme($event)" />
              <span class="slider round"></span>
            </label>
          </div>
        </div>
      </div>

      <div class="section-router">
        <router-outlet></router-outlet>
      </div>

      <app-generate-content-queue-indicator></app-generate-content-queue-indicator>
    </div>
  </div>
  <div class="footer">
    <p class="title">
      {{ "eStore " | translate }}&copy; {{ " Copyright " | translate }}
      {{ currentYear }}
    </p>
  </div>
  <!-- Phone tab bar (≤800px): the daily pages one tap away; Menu opens the menu sheet -->
  <nav class="mobile-tabbar">
    <button type="button" class="mobile-tab" [class.active]="router.url.startsWith('/dashboard/overview')"
      (click)="goTo('/dashboard/overview')">
      <i class="fi fi-rr-home"></i>
      <span>{{ "Dashboard" | translate }}</span>
    </button>
    <button type="button" class="mobile-tab" [class.active]="
        router.url.startsWith('/dashboard/orders') ||
        router.url.startsWith('/dashboard/order-subscription')
      " (click)="goTo('/dashboard/orders')">
      <i class="fi fi-rr-ticket"></i>
      <span>{{ "Orders" | translate }}</span>
    </button>
    <button type="button" class="mobile-tab" [class.active]="
        router.url.startsWith('/dashboard/express-checkout') &&
        !router.url.startsWith('/dashboard/express-checkout-dashboard')
      " (click)="goTo('/dashboard/express-checkout')">
      <i class="fi fi-rr-shopping-cart"></i>
      <span>{{ "Checkout" | translate }}</span>
    </button>
    <button type="button" class="mobile-tab" [class.active]="
        router.url.startsWith('/dashboard/visitor-intelligence') ||
        router.url.startsWith('/dashboard/replay')
      " (click)="goTo('/dashboard/visitor-intelligence')">
      <i class="fi fi-rr-eye"></i>
      <span>{{ "Visitors" | translate }}</span>
    </button>
    <button type="button" class="mobile-tab" (click)="collapseMenuMobile()">
      <i class="fi fi-rr-menu-burger"></i>
      <span>{{ "Menu" | translate }}</span>
    </button>
  </nav>
  <div class="bg-overlay" *ngIf="mobileToggle" (click)="collapseMenuMobile()"></div>
</div>